<!-- @format -->

<div
	class="input-container hmf-round-radius hmf-position-relative">
	<input
		class="input-field hmf-body-l hmf-display-block hmf-round-radius hmf-py-xs hmf-py-m-s hmf-px-s"
		type="search"
		name="search"
		enterkeyhint="search"
		[(ngModel)]="searchFieldValue"
		[ngClass]="{ 'hmf-pr-xxxl': isFocus, 'hmf-pl-xl': !isFocus, activated: !!searchFieldValue }"
		[placeholder]="placeholder"
		(keydown.enter)="searchValue()"
		(focus)="setFocus(true)"
		(blur)="setFocus(false)" />

	<div
		class="search-container hmf-position-absolute hmf-display-flex"
		[ngClass]="{
			'right hmf-header-xs hmf-pr-xs hmf-pr-m-s': !!searchFieldValue,
			'left hmf-pl-s hmf-pr-xxs': !isFocus
		}">
		<ng-container *ngIf="!!searchFieldValue">
			<button
				class="clear hmf-p-0 hmf-mr-xs"
				tabindex="0"
				(click)="clearQuery()">
				Clear
			</button>
			<div class="separator hmf-mr-xs hmf-my-xs hmf-my-m-s"></div>
		</ng-container>

		<ng-container *ngIf="!isFocus || !!searchFieldValue">
			<button
				class="search hmf-p-0"
				name="search"
				aria-label="Search"
				[tabindex]="isFocus ? 0 : -1"
				(click)="searchValue()">
				<homefield-icon
					class="search-icon"
					name="search"
					[ngClass]="{ 'has-focus': isFocus }"
					[width]="isMobileSize() ? '20px' : '24px'"
					[height]="isMobileSize() ? '20px' : '24px'"
					fill="var(--hmf-gray700)">
				</homefield-icon>
			</button>
		</ng-container>
	</div>
</div>
